module.exports = __webpack_public_path__ + "static/media/2.0c5a4b7c.jpg";